import type { Authentication } from './types';
import { AsyncLocalStorage } from 'node:async_hooks';

export interface SecurityContext {
    authentication?: Authentication;
}

export class AsyncStorageSecurityContextHolder {
    private static hasSecurityContext(storage: AsyncLocalStorage<{
        securityContext?: Promise<SecurityContext>
    }>): boolean {
        return storage.getStore()?.securityContext !== undefined;
    }

    private static async getSecurityContext(storage: AsyncLocalStorage<{
        securityContext?: Promise<SecurityContext>
    }>): Promise<SecurityContext | undefined> {
        return await storage.getStore()?.securityContext;
    }

    public static clearSecurityContext(storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>) {
        delete storage.getStore()?.securityContext;
    }

    public static withSecurityContext(securityContext: Promise<SecurityContext>) {
        return (storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }> = new AsyncLocalStorage<{
            securityContext?: Promise<SecurityContext>
        }>()) => {
            storage.getStore()!.securityContext = securityContext;
            return storage;
        };
    }

    public static withAuthentication(authentication: Authentication) {
        return AsyncStorageSecurityContextHolder.withSecurityContext(Promise.resolve({authentication}));
    }

    public static async getContext(storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>): Promise<SecurityContext | undefined> {
        if (AsyncStorageSecurityContextHolder.hasSecurityContext(storage)) {
            return AsyncStorageSecurityContextHolder.getSecurityContext(storage);
        }
    }
}

